/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component, OnInit, computed, inject, input, output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Feedback option interface
 */
export interface FeedbackOption {
    id: string;
    value: string;
    text: string;
    checked?: boolean;
}

/**
 * Feedback data interface
 */
export interface FeedbackData {
    selectedOption: string;
    additionalFeedback?: string;
}

/**
 * User Feedback Component
 * 
 * Provides a feedback form for collecting user opinions on bot responses.
 * Supports predefined options (inaccurate, incomplete, etc.) and custom feedback.
 * 
 * @example
 * <app-user-feedback 
 *   [feedbackOptions]="customOptions"
 *   (feedbackSubmit)="handleFeedback($event)">
 * </app-user-feedback>
 */
@Component({
    selector: 'app-user-feedback',
    templateUrl: './user-feedback.component.html',
    styleUrl: './user-feedback.component.scss',
    standalone: false
})
export class UserFeedbackComponent implements OnInit {
    readonly translate = inject(TranslateService);

    /** Array of feedback options to display (uses defaults if not provided) */
    readonly feedbackOptions = input<FeedbackOption[]>([]);

    /** Emits when feedback selection changes */
    readonly feedbackChange = output<FeedbackData>();

    /** Emits when feedback is submitted */
    readonly feedbackSubmit = output<FeedbackData>();

    /** Currently selected feedback option value */
    selectedOption: string = '';

    /** Additional text feedback when 'Other' is selected */
    additionalFeedback: string = '';

    /** Controls visibility of the 'Other' textarea */
    showOtherTextarea: boolean = false;

    /** Default feedback options if none provided */
    private defaultOptions: FeedbackOption[] = [
        { id: '1', value: 'inaccurate', text: 'Inaccurate', checked: false },
        { id: '2', value: 'incomplete', text: 'Incomplete', checked: false },
        { id: '3', value: 'needs_additional_info', text: 'Needs additional information', checked: false },
        { id: '4', value: 'other', text: 'Other', checked: false }
    ];

    /** Computed property for active feedback options */
    readonly activeFeedbackOptions = computed(() => {
        const options = this.feedbackOptions();
        if (!options || options.length === 0) {
            return this.defaultOptions;
        }
        return options.map(option => ({
            ...option,
            checked: option.checked || false
        }));
    });

    /**
     * Initialize component with feedback options
     */
    ngOnInit(): void {
        // Initialization is now handled by the computed signal
    }

    /**
     * Handle feedback option selection
     * Updates checked states and shows/hides 'Other' textarea
     * 
     * @param selectedOption - The feedback option that was selected
     */
    onOptionChange(selectedOption: FeedbackOption): void {
        // Update checked status for all options
        const options = this.activeFeedbackOptions();
        options.forEach(option => {
            option.checked = option.id === selectedOption.id;
        });

        this.selectedOption = selectedOption.value;
        this.showOtherTextarea = selectedOption.value === 'other';

        // Clear additional feedback if not "other" option
        if (!this.showOtherTextarea) {
            this.additionalFeedback = '';
        }

        this.emitFeedbackChange();
    }

    /**
     * Handle changes to additional feedback text
     */
    onAdditionalFeedbackChange(): void {
        this.emitFeedbackChange();
    }

    /**
     * Emit current feedback data to parent component
     * @private
     */
    private emitFeedbackChange(): void {
        const feedbackData: FeedbackData = {
            selectedOption: this.selectedOption,
            additionalFeedback: this.additionalFeedback || undefined
        };

        this.feedbackChange.emit(feedbackData);
    }

    /**
     * Submit feedback to parent component
     * Only submits if valid feedback is selected
     */
    submitFeedback(): void {
        if (this.selectedOption) {
            const feedbackData: FeedbackData = {
                selectedOption: this.selectedOption,
                additionalFeedback: this.additionalFeedback || undefined
            };

            this.feedbackSubmit.emit(feedbackData);
        }
    }

    /**
     * Reset feedback form to initial state
     * Clears all selections and text inputs
     */
    resetFeedback(): void {
        this.selectedOption = '';
        this.additionalFeedback = '';
        this.showOtherTextarea = false;

        // Reset all checked states
        const options = this.activeFeedbackOptions();
        options.forEach(option => {
            option.checked = false;
        });

        this.emitFeedbackChange();
    }

    /**
     * Check if current feedback is valid for submission
     * Requires an option selected and additional text if 'Other' is chosen
     * 
     * @returns True if feedback is valid
     */
    get isValidFeedback(): boolean {
        return this.selectedOption !== '' &&
            (this.selectedOption !== 'other' || this.additionalFeedback.trim() !== '');
    }
}